import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class LendersAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  // Generic lender endpoints
  getLenders(router) {
    const url = "/api/lenders";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getLendersById(id, router) {
    const url = `/api/lenders/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  createLenders(params, router) {
    const url = "/api/lenders";
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateLenders(id, params, router) {
    const url = `/api/lenders/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteLenders(id, router) {
    const url = `/api/lenders/${id}`;
    return this.CommonAPIService.deleteCall(url, router);
  }

  // Lender To Student Map endpoints
  getLenderToStudentMap(router) {
    const url = "/api/lenders/lenderToStudentMap";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getLenderToStudentMapById(id, router) {
    const url = `/api/lenders/lenderToStudentMap/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  createLenderToStudentMap(params, router) {
    const url = "/api/lenders/lenderToStudentMap";
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateLenderToStudentMap(id, params, router) {
    const url = `/api/lenders/lenderToStudentMap/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteLenderToStudentMap(id, router) {
    const url = `/api/lenders/lenderToStudentMap/${id}`;
    return this.CommonAPIService.deleteCall(url, router);
  }

  // Potential Lender To Student Map endpoints
  getPotentialLenderToStudentMap(router) {
    const url = "/api/lenders/potentialLenderToStudentMap";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getPotentialLenderToStudentMapById(id, router) {
    const url = `/api/lenders/potentialLenderToStudentMap/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getPotentialLenderToStudentMapByUserId(userId, router) {
    const url = `/api/lenders/potentialLenderToStudentMap/user/${userId}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  createPotentialLenderToStudentMap(params, router) {
    const url = "/api/lenders/potentialLenderToStudentMap";
    return this.CommonAPIService.postCall(url, params, router);
  }

  updatePotentialLenderToStudentMap(id, params, router) {
    const url = `/api/lenders/potentialLenderToStudentMap/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deletePotentialLenderToStudentMap(id, router) {
    const url = `/api/lenders/potentialLenderToStudentMap/${id}`;
    return this.CommonAPIService.deleteCall(url, router);
  }

  // Lender Payments endpoints
  getLenderPayments(router) {
    const url = "/api/lenders/lenderPayments";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getLenderPaymentsById(id, router) {
    const url = `/api/lenders/lenderPayments/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  createLenderPayments(params, router) {
    const url = "/api/lenders/lenderPayments";
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateLenderPayments(id, params, router) {
    const url = `/api/lenders/lenderPayments/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteLenderPayments(id, router) {
    const url = `/api/lenders/lenderPayments/${id}`;
    return this.CommonAPIService.deleteCall(url, router);
  }

  // Custom lender functions
  getLenderDetailsWithStudentsById(id, router) {
    const url = `/api/lenders/${id}/detailsWithStudents`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getLenderWithTotalAmountLent(id, router) {
    const url = `/api/lenders/${id}/totalAmountLent`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getLenderSchoolsById(id, router) {
    const url = `/api/lenders/${id}/schools`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getLenderStudentsDetailsById(id, router) {
    const url = `/api/lenders/${id}/students`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getLenderSchoolsWithStudents(id, router) {
    const url = `/api/lenders/${id}/schoolsWithStudents`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getLenderGradeBook(id, router) {
    const url = `/api/lenders/${id}/lenderGradebook`;
    return this.CommonAPIService.getCall(url, "", router);
  }
}

export default LendersAPIService;
